import { useState } from "react";

import { useAuth } from "../../../../../store/AuthContext/AuthContext";
import { useFetch } from "../../../../../hooks/useFetch/useFetch";
import { Drawer, Modal, Space } from "antd";
import TableLZM from "../../../../components/design/table/TableLZM";
import { ReportType } from "../../../../components/design/reports/ReportType";
import { ReportSendStatus } from "../../../../components/design/reports/ReportSendStatus";
import moment from "moment";
import { ButtonLZ } from "../../../../components/design/Buttons/ButtonLZ";
import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { PreviewReportModal } from "./PreviewReportModal";
import { SpinLZ } from "../../../../components/design/Spinner/SpinLZ";
import { DrawerPanelTitle, drawerPanelStyles } from "../../../common/Drawers/DrawerPanelTitle";
import { ReportPeriodDisplay } from "../reportPeriodUtils";
import { customRequest } from "../../../../../common/request/customRequest";
import { t } from "i18next";

export const ReportLogsDrawer = (props: {
    reportInfo: { type: string, locationId?: string };
    onFinish: (changed?: boolean) => void;
}) => {
                        
    const { projectGroup } = useAuth();    
	const [showPreviewModal, setShowPreviewModal] = useState<any>(null);
    const [updateData, setUpdateData] = useState(false);
    const [changed, setChanged] = useState(false);
    const locationIdOpt = props.reportInfo.locationId ? `/${props.reportInfo.locationId}` : '';
    
    const { data: reportLogs, isLoading }: any = useFetch(
        `${process.env.REACT_APP_API}/projects/${projectGroup.project}/server-reports${locationIdOpt}/type/${props.reportInfo.type}/report-logs`,
        {},
        [updateData]
    );

    const deleteReportLog = (reportLogId: string) => {
        Modal.confirm({
            title: '¿Confirmas que quieres eliminar este informe?',
            okText: t('dictionary.confirm'),
            cancelText: t('dictionary.cancel'),
            okButtonProps: { danger: true },
            onOk: async () => {
                await customRequest(
                    `${process.env.REACT_APP_API}/projects/${projectGroup.project}/server-reports/report-logs/${reportLogId}`,
                    { method: 'DELETE' }
                );
                setChanged(true);
                setUpdateData(!updateData);
            },
        });
    };

    const columns = [
        {
            title: 'Título',
            dataIndex: 'title',
            key: 'title',
            render: (_: any, record: any) => (
                <div>
                    <span>{record.title}</span>
                    <br />
                    <span style={{ fontSize: 12, color: '#93a3b8' }}>
                        {record.created && (
                            <>
                                Creado:&nbsp;
                                {moment(record.created).format('D MMM YYYY, HH:mm')}
                            </>
                        )}
                    </span>
                </div>
            ),
        },
        {
            title: 'Tipo',
            key: 'type',
            render: (_: any, record: any) => (
                <span>
                    <ReportType
                        reportType={record.reportType}
                        scope={true}
                    />
                </span>
            ),
        },
        {
            title: 'Periodo',
            key: 'period',
            render: (_: any, record: any) => (
                <ReportPeriodDisplay
                    openTime={record.openTime}
                    closeTime={record.closeTime}
                    scheduledType={record.scheduledType}
                />
            ),
        },
        {
            title: 'Envío',
            key: 'send',
            render: (_: any, record: any) => (
                <ReportSendStatus
                    sent={!!record.sentAt}
                    sentTo={record.sentTo}
                    failedTo={record.failedTo}
                />
            ),
        },
        {
            title: '',
            key: 'actions',
            align: 'center',
            render: (_: any, record: any) => (
                <Space size={4}>
                    <ButtonLZ
                        size='small'
                        onClick={() =>
                            setShowPreviewModal({
                                type: record.reportType,
                                schedule_type: record.scheduledType,
                                locationId: props.reportInfo.locationId,
                                logId: record.id,
                                openTime: record.openTime,
                                closeTime: record.closeTime,
                            })
                        }
                        type='primary'
                    >
                        <EyeOutlined />
                    </ButtonLZ>
                    <ButtonLZ
                        size='small'
                        type='default'
                        onClick={() => deleteReportLog(record.id)}
                    >
                        <DeleteOutlined />
                    </ButtonLZ>
                </Space>
            ),
        }
    ];

    return (        
            <Drawer
                placement="right"
                width={'80%'}
                open={true}
                onClose={() => props.onFinish(changed)}
                {...drawerPanelStyles}
                bodyStyle={{ ...drawerPanelStyles.bodyStyle, padding: '0px 10px' }}
                title={
                    <DrawerPanelTitle title="Histórico de informes generados" />
                }
            >
                {isLoading ? 
                    <SpinLZ/>
                    :
                    <TableLZM
                        style={{ margin: '20px' }}
                        dataSource={reportLogs}
                        rowKey="id"
                        pagination={false}
                        columns={columns}
                    />
                }
                {showPreviewModal && <PreviewReportModal reportInfo={showPreviewModal} onFinish={() => {setShowPreviewModal(null)}} />}
            </Drawer>
        );
};
